import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ef96246"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "join-community__green-stripe" }
const _hoisted_2 = { class: "join-community__section" }
const _hoisted_3 = { class: "join-community__stripe" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "join-community__info-text" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "join-community__title margin-title" }, " Talk to us! ")
], -1))
const _hoisted_5 = { class: "join-community__soc-links" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "join-community__soc-link" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "70",
    height: "70",
    src: "/twitter.svg"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "join-community__soc-link" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "71",
    height: "55",
    src: "/discord.svg"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "join-community__soc-link" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "73",
    height: "73",
    src: "/github.svg"
  })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "join-community__soc-link" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "73",
    height: "73",
    src: "/youtube.svg"
  })
], -1))
const _hoisted_17 = [
  _hoisted_16
]

import { linkTo } from '@/constants'

export default /*#__PURE__*/_defineComponent({
  __name: 'JoinCommunity',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            href: _unref(linkTo).twitter,
            target: "_blank"
          }, _hoisted_8, 8, _hoisted_6),
          _createElementVNode("a", {
            class: "join-community__soc-links-right",
            href: _unref(linkTo).discord,
            target: "_blank"
          }, _hoisted_11, 8, _hoisted_9),
          _createElementVNode("a", {
            class: "join-community__soc-links-right",
            href: _unref(linkTo).github,
            target: "_blank"
          }, _hoisted_14, 8, _hoisted_12),
          _createElementVNode("a", {
            class: "join-community__soc-links-right",
            href: _unref(linkTo).youtube,
            target: "_blank"
          }, _hoisted_17, 8, _hoisted_15)
        ])
      ])
    ])
  ]))
}
}

})